import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { Send, Loader2, Paperclip } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function TicketReplyActions({ isEdited, isSending, isUploading, hasContent, onSend, onAttach }) {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col-reverse sm:flex-row justify-between gap-2">
            <div className="flex items-center gap-2">
                <Button variant="outline" size="icon" className="h-8 w-8" onClick={onAttach} disabled={isUploading}
                    title={t("support.ticketDetail.attachFile", "Attach file")}>
                    {isUploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Paperclip className="w-4 h-4" />}
                </Button>
                <span className="text-xs text-muted-foreground">{t("support.ticketDetail.maxFileSize", "Max 20 MB per file")}</span>
            </div>
            <div className="flex flex-col-reverse sm:flex-row gap-2">
                {isEdited && (
                    <Button onClick={() => onSend(true)} disabled={isSending || !hasContent} className="w-full sm:w-auto">
                        {isSending ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />}
                        {t("admin.support.sendAndImprove", "Send & Improve AI")}
                    </Button>
                )}
                <Button variant={isEdited ? "outline" : "default"} onClick={() => onSend(false)} disabled={isSending || !hasContent} className="w-full sm:w-auto">
                    {isSending ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />}
                    {t("admin.support.sendReply", "Send Reply")}
                </Button>
            </div>
        </div>
    );
}
